module.exports = __webpack_public_path__ + "media/images/top/icon/white/ico_arrow_triangle_right-d83f26dd44b1c498ed1ee1892f9e44a3.svg";